import React, { FC } from 'react';
import { Container, ContentLoader } from './styles';

const Loader: FC = () => {
  return (
    <Container>
      <ContentLoader viewBox="0 0 486 536">
        <path
          opacity="0.5"
          d="M442.351 157.774C453.531 150.284 474.1 146.547 483.204 143.921C484.564 143.529 486 144.54 486 145.955V528H81V287.779C81 285.16 82.0226 282.655 83.8257 280.755C95.9947 267.931 116.713 244.585 130.99 244.584C146.442 244.584 156.331 257.953 176.702 261.49C201.386 265.776 199.253 268.095 210.25 273.547C221.246 278.999 231.094 282.522 243.352 280.8C266.349 277.569 282.096 257.733 301.367 254.565C318.827 251.695 329.48 224.911 335.026 213.766C340.817 202.129 348.619 184.459 364.15 184.538C379.68 184.618 388.682 193.588 404.495 188.663C422.593 183.027 432.741 164.213 442.351 157.774Z"
        />
        <rect y="104" width="48" height="16" rx="8" />
        <rect y="208" width="48" height="16" rx="8" />
        <rect y="312" width="48" height="16" rx="8" />
        <rect y="416" width="48" height="16" rx="8" />
        <rect y="520" width="48" height="16" rx="8" />
        <rect width="48" height="16" rx="8" />
      </ContentLoader>
    </Container>
  );
};

export default Loader;
